import { render, staticRenderFns } from "./myUploader.vue?vue&type=template&id=485eb45a&"
import script from "./myUploader.vue?vue&type=script&lang=js&"
export * from "./myUploader.vue?vue&type=script&lang=js&"
import style0 from "./myUploader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/myz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485eb45a')) {
      api.createRecord('485eb45a', component.options)
    } else {
      api.reload('485eb45a', component.options)
    }
    module.hot.accept("./myUploader.vue?vue&type=template&id=485eb45a&", function () {
      api.rerender('485eb45a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/vue/web/page/components/myUploader.vue"
export default component.exports